/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：206
 */

"use strict"

var r
export { r as a };
(function (e) {
  e.CONTAIN = "contain"
  e.COVER = "cover"
  e.STRETCH = "stretch"
})(r || (r = {}))
export default r
